import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PopupInfo from "@/components/popup/PopupInfo.vue";
import { MutationTypes, store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupInfoDeleteMessages',
  setup(__props) {

const clickAction = () => {
  store.commit(MutationTypes.HIDE_POPUP);
  store.commit(MutationTypes.SET_SELECTING_MESSAGES, {
    selecting: true,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupInfo, {
    title: "popup.PopupInfoDeleteMessages.title",
    label: "popup.PopupInfoDeleteMessages.label",
    "btn-text": "popup.PopupInfoDeleteMessages.btnText",
    action: clickAction
  }))
}
}

})